export * from './NavigatorItemDesktop';
export type { NavigatorItemDesktopProps } from './types';

// Export related public API types shared with `NavigatorItemMobile` (NOTE: we only need to export these types once).
export type { NavigatorFeaturedItemProps } from '../NavigatorItemFeaturedLink/types';
export type { NavigatorItemProps } from '../NavigatorItemLink/types';
